import { render, staticRenderFns } from "./FindGroupDialog.vue?vue&type=template&id=87d9e9f8&"
import script from "./FindGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./FindGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FindGroupDialog.vue?vue&type=style&index=0&id=87d9e9f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports